import PropTypes from 'prop-types'
import { usePermissionsStore } from '../../services/permissionsStore'

export const checkPermission = (permission) => {
  return usePermissionsStore.getState().hasPermission(permission)
}

function Authorization({ permission, children }) {
  return checkPermission(permission) ? children : null
}

Authorization.propTypes = {
  permission: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

export default Authorization


export function SkipAuthorizationOnCompanyCreate({ isCompanyCreate, permission, children }) {
  if (isCompanyCreate) {
    return children
  }

  return <Authorization permission={permission}>{children}</Authorization>
}